var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "pb-6" },
    [
      _vm.currentUser
        ? _c(_vm.templateData, {
            tag: "component",
            attrs: { userId: _vm.currentUser.id },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }